import React, { Component } from 'react';
import notes from '../../resources/images/estrategas/tools/notes.png';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import AddNote from './addNoteNewBusiness';
import DeleteNote from './deleteNoteNewBusienss';
import EditNote from './editNoteNewBusiness';

class NoteNewBusiness extends Component{
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.callback = this.callback.bind(this);
    this.showNotes = this.showNotes.bind(this);
    this.state = { modal: false };
  }

  toggle(){
    this.setState({ modal: !this.state.modal })
  }

  callback(dataFromChild){
    this.props.callbackFromParent(dataFromChild);
    this.toggle()
  }

  showNotes(notes) {
    this.notes = this.props.authorization ? notes.map(note => (<div>
      <div className="row pr-3 pl-3 pb-3">
        <div className="col-10 note-text">
          <div>{note.note}</div>
          <small>
            <div align="right">{note.registry}</div>
          </small>
        </div>
        <div className="col-1">
          <EditNote authorization={this.props.authorization} note={note} callbackFromParent={this.callback} />
        </div>
        <div className="col-1">
          <DeleteNote authorization={this.props.authorization} id={note.id} callbackFromParent={this.callback} />
        </div>
      </div>
    </div>), this.toggle()) : notes.map(note => (<div>
      <div className="row pr-3 pl-3 pb-3">
        <div className="col-12 note-text">
          <div>{note.note}</div>
          <small>
            <div align="right">{note.registry}</div>
          </small>
        </div>
      </div>
    </div>), this.toggle());
  }

  render() {
    return (
      <div>
        <div className="notes-incidence-icon" onClick={() => this.showNotes(this.props.notes)}>
          <img src={notes} title="Notas" alt="" />
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader className="header-modal" toggle={this.toggle}>
            <div className="d-flex justify-content-around">
              <AddNote authorization={this.props.authorization} id={this.props.id} callbackFromParent={this.callback} />
              Observaciones de los responsables
            </div>
          </ModalHeader>
          <ModalBody className="scroll-modal" key={this.state.keyNote}>
            {this.notes}
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>Cerrar</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default NoteNewBusiness;



// WEBPACK FOOTER //
// ./src/components/buttons/noteNewBusiness.js